import React, { createContext, useMemo, useState } from 'react';

export const PageContext = createContext(null);

function Context({ children }) {
  const [pageType, setPageType] = useState(null);
  const contextValue = useMemo(() => ({ pageType, setPageType }), [pageType, setPageType]);
  return <PageContext.Provider value={contextValue}>{children}</PageContext.Provider>;
}

export default Context;
